<onyx-badge [color]="statusColor()" [size]="20">
  {{ statusName() | translate }}
</onyx-badge>

@if (!isOrderInactive()) {
  <app-order-modal-stages [order]="order()"></app-order-modal-stages>
}

<span>·</span>

@let sender = order().basicInformation.sender;
<onyx-link
  color="black"
  [ellipsis]="true"
  (click)="contractorHelper.openModal(sender)"
>
  {{ sender.companyProfile.displayName }}
</onyx-link>

<span>·</span>

<app-amount-cell
  [amount]="order().price"
  show="defaultCurrency"
  [short]="true"
></app-amount-cell>
